import React from "react"
import BoardOfDirectorsComponent from "./BoardOfDirectors"
import boardOfDirectorsFactory from "./boardOfDirectors.factory"

export { default as BoardOfDirectorsQuery } from "./boardOfDirectors.query"

export const BoardOfDirectors = props => {
  const { data } = props
  const componentProps = { ...props, ...boardOfDirectorsFactory.transform(data) }
  return <BoardOfDirectorsComponent {...componentProps} />
}
